import React, { useEffect, useLayoutEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import { AppView, ButtonGroup, rem } from 'design-system';
import Button from 'design-system/Button';
import Text from 'design-system/Text';
import StatusBar from 'design-system/StatusBar';
import TransactionLogo from 'features/transactions/components/TransactionLogo';
import useColors from 'hooks/useColors';
import { normalizeHandleForDisplay } from './util';
const ConfirmMerchantScreen = ({ navigation, route, }) => {
    const colors = useColors();
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    const { keyBack, transactionId, merchantData } = route.params ?? {};
    useEffect(() => {
        if (!(transactionId && merchantData)) {
            if (navigation.canGoBack()) {
                navigation.goBack();
            }
            else {
                navigation.navigate('Feed');
            }
        }
    }, [merchantData, transactionId]);
    const onPressConfirm = () => {
        if (!transactionId || !merchantData) {
            return;
        }
        // confirming the right merchant data. the next screen confirms the edit action
        navigation.navigate('PreviewMerchantOverride', {
            keyBack,
            transactionId,
            merchantData,
        });
    };
    const onPressBack = () => {
        navigation.goBack();
    };
    if (!merchantData) {
        return null;
    }
    return (<AppView avoidHeader paddingBottom>
      <StatusBar animated barStyle="dark-content"/>
      <View style={styles.content}>
        <View style={styles.result}>
          <TransactionLogo R70 transaction={{ suggestedData: merchantData }}/>
          <Text Text-20 centered>
            {normalizeHandleForDisplay(merchantData)}
          </Text>
        </View>
        <Text TextThin-16 Secondary centered style={styles.note}>
          Is this merchant correct?{'\n'}You can go back and edit it
        </Text>
      </View>
      <ButtonGroup>
        <Button brandReversed title="Go back" onPress={onPressBack} testID="backButton"/>
        <Button brand title="Confirm merchant" onPress={onPressConfirm} testID="confirmButton"/>
      </ButtonGroup>
    </AppView>);
};
const styles = StyleSheet.create({
    content: {
        flex: 1,
        justifyContent: 'center',
    },
    result: {
        alignItems: 'center',
        marginVertical: rem(16),
        gap: rem(16),
    },
    note: {
        marginTop: rem(8),
        marginBottom: rem(16),
    },
});
export default ConfirmMerchantScreen;
